import { Directive, HostListener, Input } from '@angular/core';

import { InlineEditComponent } from './inline-edit.component';

@Directive({
  selector: '[appEditOnEnter]',
  standalone: false,
})
export class EditOnEnterDirective {
  @Input('appEditOnEnter') blur;

  constructor(private editable: InlineEditComponent) {}

  @HostListener('keyup.enter', ['$event'])
  onEnter($event) {
    if (this.blur === '' || !!this.blur) {
      $event.target.blur();
    }
    $event.preventDefault();

    this.editable.toViewMode();
  }

  @HostListener('keyup.escape', ['$event'])
  onEscape($event) {
    $event.preventDefault();

    this.editable.toViewMode(true);
  }
}
